import styled, { css } from 'styled-components';

export const Card = styled.div`
  ${({ theme, width, empty }) => css`
    background: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: ${width === '100' ? 'space-evenly' : 'flex-start'};
    padding: 24px 20px;
    position: relative;
    width: 100%;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      padding: 24px;
      width: ${`calc(${width || 70}% - ${!width || width === 100 ? '0px' : '8px'})`};
      border-radius: 16px;
      
      ${empty === 'true' && css`
        flex-direction: ${width === '100' ? 'row' : 'collum'};
      `};
    }
  `}
`;

export const Divisor = styled.div`
  ${({ theme, width, empty }) => css`
    ${empty === 'false' && css`
      border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
    `}

    ${empty === 'true' && width === '100' && css`
      border-left: 1px solid ${theme.v2.colors.neutral.highMedium};

      @media (max-width: ${theme.v2.breakpoints.md}) {
        border-left: 0;
        border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
      }
    `}
    
    ${empty === 'true' && width !== '100' && css`
      border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
    `}
  `}
`;

export const SkeletonElement = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-bottom: 48px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
      margin-bottom: 24px;
    }
  `}
`;

export const SkeletonParagraph = styled.div`
  ${({ theme, firstParagraph }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    margin-top: ${firstParagraph ? '40px' : '32px'};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 12px;
      margin-top: ${firstParagraph ? '28px' : '20px'};
    }
  `}
`;

export const SkeletonTexts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
